import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/global-background.css";
import "../styles/HomePage.css";

const HomePage: React.FC = () => {
  const [language, setLanguage] = useState<"en" | "zh">("zh");
  const navigate = useNavigate();

  useEffect(() => {
    const fromTwitter = new URLSearchParams(window.location.search).get(
      "state"
    );
    const bound = localStorage.getItem("twitterBound");
    const username = localStorage.getItem("twitterUsername");

    if (fromTwitter && bound === "true" && username) {
      message.success(`欢迎回来，@${username} 🎉`);
      window.history.replaceState({}, document.title, window.location.pathname); // 清理 URL
    }
  }, []);

  return (
    <div className="nova-container">
       {/* 安全声明横幅 */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(255, 69, 0, 0.9), rgba(255, 140, 0, 0.9))',
        border: '2px solid rgba(255, 69, 0, 0.8)',
        borderRadius: '8px',
        padding: '12px 20px',
        margin: '100px auto 25px auto',
        maxWidth: '800px',
        textAlign: 'center',
        boxShadow: '0 4px 15px rgba(255, 69, 0, 0.3)',
        animation: 'securityBannerGlow 3s ease-in-out infinite alternate',
        paddingTop: '10px',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
          fontFamily: 'var(--text-font)',
          textShadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
          letterSpacing: '0.5px'
        }}>
          🔒 {language === "en" 
            ? "Security Notice: Our official website is https://novacrafterlab.xyz/ - Stay safe from phishing sites!" 
            : "安全提醒：我们的官方网站仅在 https://novacrafterlab.xyz - 请注意防范钓鱼网站！"}
        </div>
      </div>
      <div className="nova-grid"></div>

      <Navbar language={language} />

      <div className="content">
        <div className="hero-section">
          <div className="title-section">
            <h1 className="nova-title">
              {language === "en" ? "Our Products" : "NovaCrafterLab"}
            </h1>
            <p className="nova-subtitle">
              {language === "en"
                ? "AI-driven game creation community"
                : "AI 驱动游戏创作社区"}
            </p>
          </div>

          <div className="hero-actions-layered">
            {/* 主要按钮层 */}
            <div className="primary-actions">
              <button
                className="glowbutton"
                onClick={() => navigate("/products")}
              >
                {language === "en" ? "Explore Products" : "探索产品"}
              </button>

              <button className="glowbutton" onClick={() => navigate("/bridge")}>
                {language === "en" ? "Bridge" : "桥接"}
              </button>
            </div>

            {/* 次要按钮层 */}
            <div className="secondary-actions">
              <button 
                className="secondary-glow-button"
                onClick={() => navigate("/clubs")}
              >
                <span style={{ position: 'relative', zIndex: 2 }}>
                  👑 {language === "en" ? "Clubs" : "俱乐部"}
                </span>
                
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'linear-gradient(45deg, #8c4fff, #a764ff)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 6px rgba(140, 79, 255, 0.4)',
                  zIndex: 3,
                  animation: 'bounce 1.5s infinite'
                }}>
                  NEW
                </span>
              </button>

              <button 
                className="secondary-glow-button"
                onClick={() => navigate("/market")}
              >
                <span style={{ position: 'relative', zIndex: 2 }}>
                  🛒 {language === "en" ? "Market" : "市场"}
                </span>
                
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'linear-gradient(45deg, #8c4fff, #a764ff)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 6px rgba(140, 79, 255, 0.4)',
                  zIndex: 3,
                  animation: 'bounce 1.5s infinite'
                }}>
                  NEW
                </span>
              </button>

              <button 
                className="secondary-glow-button"
                onClick={() => navigate("/battle-prediction")}
              >
                <span style={{ position: 'relative', zIndex: 2 }}>
                  🏆 {language === "en" ? "Battle Prediction" : "主播赛竞猜"}
                </span>
                
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'linear-gradient(45deg, #8c4fff, #a764ff)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 6px rgba(140, 79, 255, 0.4)',
                  zIndex: 3,
                  animation: 'bounce 1.5s infinite'
                }}>
                  NEW
                </span>
                
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  left: '-8px',
                  background: 'linear-gradient(45deg, #ff9500, #ffaa44)',
                  color: 'white',
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 6px rgba(255, 149, 0, 0.4)',
                  zIndex: 3,
                  animation: 'glow 2s ease-in-out infinite alternate'
                }}>
                  HOT
                </span>
              </button>
            </div>
          </div>
        </div>

        <div className="features-section prominent-layout">
          <div className="side-cards">
            <div className="feature-card news-card">
              <h3>{language === "en" ? "News" : "新闻"}</h3>
              <p>
                {language === "en"
                  ? "The latest news and updates from Nova Crafter Lab"
                  : "Nova Crafter La`Fb 新闻和更新"}
              </p>
              <Button type="link" onClick={() => navigate("/hub")}>
                {language === "en" ? "Learn more" : "了解更多"} →
              </Button>
            </div>
            <div className="feature-card gallery-card">
              <h3>{language === "en" ? "Gallery" : "图鉴"}</h3>
              <p>
                {language === "en"
                  ? "Browse our collection of game assets and NFTs"
                  : "浏览我们的游戏资产和NFT收藏"}
              </p>
              <Button type="link" onClick={() => navigate("/gallery")}>
                {language === "en" ? "Explore" : "探索"} →
              </Button>
            </div>
          </div>
        </div>

        <Footer language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
};

export default HomePage;
